const { isPlaceholder } = require('./public-content')
const { isHealthContent } = require('./content-categories')

// Use the same selection for Gatsby page counts and the rendered article list.
function getListArticles(articles, category) {
  return articles.filter(article => article && !isPlaceholder(article) &&
    (article.categorie || []).length > 0 &&
    (category === 'sanita' ? isHealthContent(article) : !isHealthContent(article)))
}

module.exports = { getListArticles }
